/**
 * Contact page: hero fade-in and CF7 submit loading state.
 */
const SELECTORS = {
    hero: '[data-contact-hero]',
    formCard: '[data-contact-form-card]',
};
const CF7_END_EVENTS = [
    'wpcf7submit',
    'wpcf7mailsent',
    'wpcf7mailfailed',
    'wpcf7invalid',
    'wpcf7spam',
    'wpcf7aborted',
];
function initContactHero() {
    const hero = document.querySelector(SELECTORS.hero);
    if (!hero) {
        return;
    }
    requestAnimationFrame(() => {
        hero.classList.add('is-visible');
    });
}
function setFormSubmitting(card, submitting) {
    card.classList.toggle('is-submitting', submitting);
    const submit = card.querySelector('input.wpcf7-submit, .contact-form__submit');
    if (submit) {
        submit.disabled = submitting;
    }
}
function initContactFormLoading() {
    const card = document.querySelector(SELECTORS.formCard);
    if (!card) {
        return;
    }
    const formBelongsToCard = (unitTag) => {
        const wrapper = card.querySelector(`#${unitTag}`);
        return Boolean(wrapper);
    };
    document.addEventListener('wpcf7beforesubmit', (event) => {
        const detail = event.detail;
        if (!detail?.unitTag || !formBelongsToCard(detail.unitTag)) {
            return;
        }
        setFormSubmitting(card, true);
    }, false);
    const clearSubmitting = (event) => {
        const detail = event.detail;
        if (!detail?.unitTag || !formBelongsToCard(detail.unitTag)) {
            return;
        }
        setFormSubmitting(card, false);
    };
    for (const name of CF7_END_EVENTS) {
        document.addEventListener(name, clearSubmitting, false);
    }
}
export function initContactPage() {
    initContactHero();
    initContactFormLoading();
}
